// extracted by css-extract-rspack-plugin
export default {"container":"container-ntJEkH","iconWrapper":"iconWrapper-ZWVtQQ"};